module.exports = __webpack_public_path__ + "static/fonts/open-sans-bold.e5111ca.ttf";